// This icon file is generated automatically.
var PFastBackwardOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.09 2.27L1.59 5.8a.25.25 0 000 .4l4.5 3.53c.16.13.41 0 .41-.2V2.47a.25.25 0 00-.41-.2zm5 0L6.59 5.8a.25.25 0 000 .4l4.5 3.53c.16.13.41 0 .41-.2V2.47a.25.25 0 00-.41-.2zm-9.69-.4H.6c-.05 0-.1.05-.1.1v8.06c0 .05.05.1.1.1h.8c.05 0 .1-.05.1-.1V1.97c0-.05-.05-.1-.1-.1z", "fill-rule": "nonzero" } }] }, "name": "p-fast-backward", "theme": "outlined" };
export default PFastBackwardOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFastBackwardOutlined.js
// module id = 3379
// module chunks = 0